// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Qd7d5","main":"App_main__Ouif1"};